import React, {useState} from 'react';
import {
    TextField,
    Checkbox,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup
} from '@material-ui/core';

//css
import Styles from './styles';
const useStyles = Styles();

export default ({
    colunas,
    searchField,
    escolhaField,
    isColunasMultiple,

    handlerClickCheckbox,
    handlerClickRadio,
    handleChangeSearchFieldPedido,
}) => {
    const classes = useStyles();

    const [value, setValue] = useState(searchField);

    const handlerOnChange = (event) => {
        setValue(event.target.value)
    };

    const handlerOnBlur = (event) => {
        handleChangeSearchFieldPedido(event);
    };

    const listaColunasCheckbox = colunas.map((col,i) =>
        <FormControlLabel
            control={
                <Checkbox
                    checked={col.value}
                    onChange={(e)=>{handlerClickCheckbox(i)}}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                />
            }
            label={col.key}
            key={i}
        />
    );

    const listaColunasRadio = colunas.map((col,i) =>
        <FormControlLabel
            key={i}
            label={col.key}
            value={col.value}
            control={<Radio/>}
        />
    );

    const FormColunasRadio = () => {
        return (
            <FormControl component="fieldset">
                <RadioGroup
                    aria-label="data"
                    name="data1"
                    value={escolhaField}
                    onChange={handlerClickRadio}
                    row
                >
                    {listaColunasRadio}
                </RadioGroup>
            </FormControl>
        );
    };

    return (
        <>
            <TextField
                className={classes.searchField}
                id="bt_pesquisarPedido"
                label="Pesquisar"
                variant="outlined"
                value={value}
                onChange={handlerOnChange}
                onBlur={handlerOnBlur}
            />
            {isColunasMultiple &&
                <>
                    {listaColunasCheckbox}
                </>
            }
            {!isColunasMultiple &&
                <FormColunasRadio/>
            }
        </>
    );
};
